export const BULK_EDIT_DEFAULT_MAX_RECORDS = 500

export const BULK_EDIT_DEFAULT_PER_PAGE = 100

export const BULK_EDIT_AUTO_ACCEPT_MIN_VISIBLE_MS = 2000

export const BULK_EDIT_FORM_ID = 'list-bulk-edit-dialog-form'

export const bulkEditDialogActionsSx = {
  px: 2.5,
  py: 2,
  gap: 1,
  flexWrap: 'wrap' as const,
}
